import React from 'react';
import { useHistory } from 'react-router-dom';

import { Card, Col, Link, Row, Typography, ViewContainer } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import featureFlags from 'constants/featureFlags';
import { ROUTE_FIND_AN_AGENT, ROUTE_NEWS_ARTICLE_ADMIN, ROUTE_RUNTIME_CONFIG } from 'constants/routes';

const AppAdmin = () => {
  const history = useHistory();

  const handleGoToRoute = (route) => history.push(route);

  return (
    <Feature allowed={featureFlags.ACCESS_APP_ADMIN}>
      <ViewContainer title={'Application Administration'} hidePolicyViewChange hideStartQuote>
        <Card>
          <Row spacing={4}>
            <Col xs={4}>
              <Typography color="textSecondary">
                The links to the right offer access to administrative resources needed to update various application information.
              </Typography>
            </Col>
            <Col xs={8}>
              <Row spacing={4}>
                <Col xs={12}>
                  <Feature allowed={featureFlags.ACCESS_CONTENT_MGMT_ADMIN}>
                    <Link onClick={() => handleGoToRoute(ROUTE_NEWS_ARTICLE_ADMIN)}>MSA News Articles</Link>
                    <Typography color="textSecondary">Manage news articles found on MSA Group.</Typography>
                  </Feature>
                </Col>
                <Col xs={12}>
                  <Feature allowed={featureFlags.ACCESS_FIND_AGENT}>
                    <Link onClick={() => handleGoToRoute(ROUTE_FIND_AN_AGENT)}>Find An Agent</Link>
                    <Typography color="textSecondary">From this screen you may update contact and location information for agents.</Typography>
                  </Feature>
                </Col>
                <Col xs={12}>
                  <Feature allowed={featureFlags.ACCESS_SUPER_ADMIN}>
                    <Link onClick={() => handleGoToRoute(ROUTE_RUNTIME_CONFIG)}>Runtime Configuration</Link>
                    <Typography color="textSecondary">Update application settings and features.</Typography>
                  </Feature>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </ViewContainer>
    </Feature>
  );
};

export default AppAdmin;
